<script setup>
const props = defineProps({
  loading: {
    type: Boolean,
    default: false
  },
  showPrevious: {
    type: Boolean,
    default: true
  },
  primaryButtonText: {
    type: String,
    required: true
  },
  primaryButtonLoadingText: {
    type: String,
    default: 'Submitting...'
  }
})

const emit = defineEmits(['previous', 'save-draft', 'submit'])

const handlePrevious = () => {
  emit('previous')
}

const handleSaveDraft = () => {
  emit('save-draft')
}

const handleSubmit = () => {
  emit('submit')
}
</script>

<template>
  <div class="bg-white rounded-2xl border border-gray-100 p-4 md:p-8 mt-8">
    <div class="grid grid-cols-2 md:flex gap-4 justify-between items-center">

      <button
        v-if="showPrevious"
        type="button"
        @click="handlePrevious"
        :disabled="loading"
        class="px-6 py-3.5 bg-gray-100 text-gray-600 font-semibold hover:bg-gray-200 rounded-xl transition-all disabled:opacity-50 flex items-center"
      >
        <span class="material-symbols-outlined mr-2 text-xl">arrow_back</span>
        Previous
      </button>

      <button
        v-else
        type="button"
        class="px-6 py-3.5 bg-gray-50 text-gray-400 font-semibold rounded-xl transition-colors cursor-not-allowed flex items-center"
        disabled
      >
        <span class="material-symbols-outlined mr-2 text-xl">arrow_back</span>
        Previous
      </button>

      <!--
        The spacer that pushes the two right-hand buttons away from Previous.
        It was `flex-grow-1`, which is not a Tailwind class in any version — it
        is the Bootstrap spelling — so it compiled to nothing and the spacer had
        no width at all.
      -->
      <span class="hidden md:block grow"></span>

      <button
          type="button"
          @click="handleSaveDraft"
          :disabled="loading"
          class="px-6 py-3.5 text-gray-700 font-semibold bg-white hover:bg-gray-50 rounded-xl transition-all disabled:opacity-50 flex items-center border border-gray-300"
        >
          <span class="material-symbols-outlined mr-2 text-xl">save</span>
          Save Draft
        </button>

      <button
          type="button"
          @click="handleSubmit"
          :disabled="loading"
          class="col-span-2 px-8 py-3.5 bg-gradient-to-r from-teal-500 to-teal-800 text-white rounded-xl font-bold hover:from-blue-700 hover:to-blue-800 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center text-base"
        >
          <span v-if="loading" class="material-symbols-outlined animate-spin mr-2 text-xl">progress_activity</span>
          {{ loading ? primaryButtonLoadingText : primaryButtonText }}
          <span v-if="!loading" class="material-symbols-outlined ml-2 text-xl">arrow_forward</span>
        </button>

    </div>
  </div>
</template>
